import React, { Component } from 'react';
import Heading from '../Heading.jsx';
import SingleSkill from './SingleSkill.jsx';

class SkillSec extends Component {
    render() {
        return (
            <div>
                <div id="skill" style={{background:'#111a28'}}>
                    <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                        <Heading heading={this.props.heading}/>
                        </div>
                    </div>
                    <div className="row mt-5">
                    <div className='col-md-6'>
                    <SingleSkill skillName='HTML & CSS' skillPer='95%' width={{width:'95%'}} />
                    <SingleSkill skillName='BOOTSTRAP' skillPer='100%' width={{width:'100%'}} />
                    <SingleSkill skillName='SASS' skillPer='50%' width={{width:'50%'}} />
                    <SingleSkill skillName='JAVASCRIPT' skillPer='50%' width={{width:'50%'}} />
                    </div>
                    <div className='col-md-6'>
                    <SingleSkill skillName='JQUERY' skillPer='80%' width={{width:'80%'}} />
                    <SingleSkill skillName='REACT JS ' skillPer='50%' width={{width:'50%'}} />
                    <SingleSkill skillName='MATERIAL UI' skillPer='80%' width={{width:'80%'}} />
                    <SingleSkill skillName='UI DESIGN' skillPer='75%' width={{width:'75%'}} />
                    </div>
                    
                    </div>
                    </div>
                    <div className="space"></div>
                </div>
            </div>
        );
    }
}

export default SkillSec;